import type { Channel, DefaultGenerics, UserResponse } from "stream-chat"

export function getChannelCreatorId(channel: Channel<DefaultGenerics>) {
  return (
    channel && channel.data && (channel.data.created_by_id || (channel.data.created_by as UserResponse | undefined)?.id)
  )
}
